import clsx from 'clsx';
import React from 'react';
import uiConfig from '../../data/uiConfig'

interface TextProps {
  children: React.ReactNode;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  paragraph?: boolean;
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  centered?: boolean;
  className?: string;
};


export const Text: React.FC<TextProps> = ({
  children,
  bold,
  italic,
  underline,
  paragraph,
  size = "medium",
  centered = false,
  className = ""
}) => {
  const classes = clsx(
    bold && 'font-bold',
    italic && 'italic',
    underline && 'underline',
    size === 'xsmall' && 'text-xs',
    size === 'small' && 'text-sm',
    size === 'medium' && 'text-base',
    size === 'large' && 'text-lg',
    size === 'xlarge' && 'text-xl',
    centered && 'block text-center',
    className,
  )
  return (
    paragraph ?
      <p className={classes}>
        {children}
      </p>
      :
      <span className={classes}>
        {children}
      </span>
  );
};